// indexeddb-service.ts
import { openDB } from 'idb';
import { Clientes } from './cliente';

export async function deleteClienteFromIndexedDB(codigo: number): Promise<void> {
    const db = await openDB('offline-db', 9);
    const tx = db.transaction('persona', 'readwrite');
    const store = tx.objectStore('persona');

    try {
        let cursor = await store.openCursor(); // Abre un cursor para recorrer los registros

        while (cursor) {
            const cliente = cursor.value;
            if (cliente.codcliente === codigo) { // Filtra por 'codcliente'
                await cursor.delete(); // Elimina la entrada actual
                console.log(`Cliente con codcliente ${cliente.codcliente} eliminado.`);
                break; // Si ya lo encuentras, puedes detener la búsqueda
            }
            cursor = await cursor.continue(); // Avanza al siguiente registro
        }

        await tx.done;
    } catch (err) {
        console.error('Error eliminando el cliente de IndexedDB', err);
    }
}


export async function getClientesFromIndexedDB(): Promise<any[]> {
    const db = await openDB('offline-db', 9);
    
    const tx = db.transaction('persona', 'readonly');
    const store = tx.objectStore('persona');
  
    // Recuperar todos los clientes
    const persona = await store.getAll();
    await tx.done; // Asegúrate de que la transacción se complete
  
    console.log('Clientes recuperados de IndexedDB:', persona);
    return persona; // Retorna la lista de clientes
  }

  export async function saveClientesToIndexedDB(clientes: any[]): Promise<void> {
    const db = await openDB('offline-db', 9, {
        upgrade(db) {
            // Verificar si el object store ya existe antes de crearlo
            if (!db.objectStoreNames.contains('persona')) {
                db.createObjectStore('persona', { autoIncrement: true });
            }
        }
    });

    // Crear una transacción en modo 'readwrite'
    const tx = db.transaction('persona', 'readwrite');
    const store = tx.objectStore('persona');

    try {
        // Iterar y añadir cada cliente a la base de datos
        for (const cliente of clientes) {
            await store.add(cliente); // Añadir cliente a la base de datos
        }

        await tx.done; // Asegurarse de que la transacción se complete
        console.log('Clientes guardados en IndexedDB');
    } catch (err) {
        console.error('Error guardando los clientes en IndexedDB:', err);
    }
}


export async function saveRequestToIndexedDB(requestData: any) {
    const db = await openDB('offline-db', 9, {
        upgrade(db) {
            db.createObjectStore('requests', { autoIncrement: true });
        }
    });

    const tx = db.transaction('requests', 'readwrite');
    await tx.store.add(requestData);
    await tx.done;
    console.log('Solicitud guardada en IndexedDB');
}


export async function getRequestsFromIndexedDB() {
    const db = await openDB('offline-db', 9);
    const tx = db.transaction('requests', 'readonly');
    const requests = await tx.objectStore('requests').getAll();
    await tx.done;
    return requests;
  }
  
  export async function removeRequestFromIndexedDB(id) {
    const db = await openDB('offline-db', 9);
    const tx = db.transaction('requests', 'readwrite');
    await tx.objectStore('requests').delete(id);
    await tx.done;
  }
